/**
 * User Invite Service – real API only.
 */

import { apiClient } from './apiClient';
import { serviceLogger } from '../utils/serviceLogger';
import * as realImpl from './real/userInviteService.real';

const wrap = (fnName) => async (...args) => {
  try {
    return await realImpl[fnName](...args);
  } catch (error) {
    serviceLogger.error(`[${fnName}] Error:`, error);
    if (error.message) {
      if (error.code) {
        const customError = new Error(error.message);
        customError.code = error.code;
        throw customError;
      }
      throw error;
    }
    throw new Error(`Failed to ${fnName.replace(/([A-Z])/g, ' $1').toLowerCase().trim()}. Please try again.`);
  }
};

export const inviteUser = wrap('inviteUser');
export const updateUser = wrap('updateUser');
export const deleteUser = wrap('deleteUser');

export const createInvitation = async (email, role) => {
  const response = await apiClient.post('api/web-api/invitations/create-invitation/', {
    email,
    role,
  });
  return response;
};

export const acceptInvitation = async (token, password) => {
  const response = await apiClient.post('api/web-api/invitations/accept-invitation/', {
    token,
    password,
  });
  return response.data;
};
